var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import bitcoin from "../../assets/img/footer/bitcoin.svg";
import dash from "../../assets/img/footer/dash.svg";
import ethereum from "../../assets/img/footer/ethereum.svg";
import litecoin from "../../assets/img/footer/litecoin.svg";
import mastercardWB from "../../assets/img/footer/mastercard.svg";
import mastercard from "../../assets/img/footer/mastercard-color.svg";
import opex from "../../assets/img/footer/opex.svg";
import usdt from "../../assets/img/footer/usdt.svg";
import tron from "../../assets/img/footer/tron.svg";
import usdc from "../../assets/img/footer/usdc.svg";
import visaWB from "../../assets/img/footer/visa.svg";
import visa from "../../assets/img/footer/visa-color.svg";
import visaPayment from "../../assets/img/payment/visa.svg";
import sol from "../../assets/img/footer/solana.svg";
import busd from "../../assets/img/footer/busd.svg";
import bnb from "../../assets/img/footer/bnb.svg";
import visaMastercard from "../../assets/img/payment/kz_pay/visa-mastercard.svg";
import qiwi from "../../assets/img/payment/kz_pay/qiwi.svg";
import woopayWallet from "../../assets/img/payment/kz_pay/woopay-wallet.svg";
import tele2 from "../../assets/img/payment/kz_pay/tele2.svg";
import altel from "../../assets/img/payment/kz_pay/altel.svg";
import beeline from "../../assets/img/payment/kz_pay/beeline.svg";
import kcell from "../../assets/img/payment/kz_pay/kcell.svg";
import activ from "../../assets/img/payment/kz_pay/activ.svg";
import applePay from "../../assets/img/payment/kz_pay/apple-pay.svg";
import googlePay from "../../assets/img/payment/kz_pay/google-pay.svg";
import halyk from "../../assets/img/payment/kz_pay/halyk.svg";
export var currency_images = [
    {
        label: "maxipay",
        img: visaMastercard
    },
    {
        label: "paybox",
        img: visaMastercard,
    },
    {
        label: "bnb",
        img: bnb
    },
    {
        label: "btc",
        img: bitcoin
    },
    {
        label: "dash",
        img: dash
    },
    {
        label: "eth",
        img: ethereum
    },
    {
        label: "ltc",
        img: litecoin
    },
    {
        label: "mastercard",
        img: mastercard
    },
    {
        label: "mastercardWB",
        img: mastercardWB
    },
    {
        label: "bironex",
        img: opex
    },
    {
        label: "usdt",
        img: usdt
    },
    {
        label: "tron",
        img: tron
    },
    {
        label: "usdc",
        img: usdc
    },
    {
        label: "visa",
        img: visa
    },
    {
        label: "visaWB",
        img: visaWB
    },
    {
        label: "sol",
        img: sol
    },
    {
        label: "busd",
        img: busd
    },
    {
        label: "visaMastercard",
        img: visaMastercard
    },
    {
        label: "qiwi",
        img: qiwi
    },
    {
        label: "woopayWallet",
        img: woopayWallet
    },
    {
        label: "woopayCard",
        img: visaMastercard
    },
    {
        label: "woopayBalance",
        // img: woopayWallet
    },
    {
        label: "tele2",
        img: tele2
    },
    {
        label: "altel",
        img: altel
    },
    {
        label: "beeline",
        img: beeline
    },
    {
        label: "kcell",
        img: kcell
    },
    {
        label: "activ",
        img: activ
    },
    {
        label: "applePay",
        img: applePay
    },
    {
        label: "googlePay",
        img: googlePay
    },
    {
        label: "halyk",
        img: halyk
    }
];
export var UZS_PROVIDERS = [
    {
        label: "visa",
        img: visaPayment
    }
];
export var KGS_PROVIDERS = [
// {
//   label: "bironex",
//   img: opex
// },
// {
//   label: "usdt",
//   img: usdt
// },
// {
//   label: "visa",
//   img: visa
// },
// {
//   label: "mastercard",
//   img: mastercard
// },   
];
export var OTHER_PROVIDERS = [
    {
        label: "usdt",
        img: usdt
    }
];
export var ONLY_FOR_DEV_PROVIDERS = [
    'btc',
    'bnb',
    'dash',
    'eth',
    'ltc',
    // 'usdt', закомментил тк идет проверка на наличие label'ов в withdraw jsx
    'tron',
    'usdc',
    'sol',
    'busd'
];
export var SERVER_PROVIDERS_CONSTANT = [
    {
        label: "btc",
        img: bitcoin
    },
    {
        label: "bnb",
        img: bnb
    },
    {
        label: "usdt",
        img: usdt
    },
    {
        label: "eth",
        img: ethereum
    },
    {
        label: "ltc",
        img: litecoin
    },
    {
        label: "sol",
        img: sol
    }
];
export var FooterProvidersKG = function () {
    return (_jsx("ul", __assign({ className: "footer-providers" }, { children: KGS_PROVIDERS.map(function (provider) { return (_jsx("li", { children: _jsx("img", { src: provider.img, alt: provider.label, style: {
                    filter: "grayscale(100%)"
                } }) }, provider.label)); }) })));
};



// WEBPACK FOOTER //
// ./src/containers/app/footer-providers.jsx